import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const ADMIN = '1787cbf5-ff58-4ae9-bbc6-8cbee75a7af3';

export const EXTERNAL_API = 'ba7a9d2e-92d7-4536-a166-79bbc2bf3312';

class LuHubImportSourceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-hub-import-source';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'hub/import/sources';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'slug',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [
        ];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [
        ];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [
        ];
    }

}

export default LuHubImportSourceAppResource;
